import { Serializer } from '@lib/store';
import { checkinCommonInitialState } from './checkin-common.reducer';
import { CheckinCommonState } from './checkin-common.state';

export const checkinCommonStorageDeserializer = (rawObject: CheckinCommonState): CheckinCommonState => {
  return {
    ...checkinCommonInitialState,
    ...rawObject,
  };
};

export const checkinCommonStorageSync: Serializer<CheckinCommonState> = {
  deserialize: checkinCommonStorageDeserializer,
};
